/**
 *添加、设置localStorage
 * @param {Object} storageMap 添加的数据对象
 * @returns 返回当前localStorage对象
 * @group Storage
 */
const setLocalStorage = (storageMap: object) => {
  for (let key in storageMap) {
    localStorage.setItem(key, storageMap[key]);
  }
  return localStorage;
};
/**
 *获取健值
 * @param {String} name 要获取的键名
 * @returns 存在时，返回相应的值；不存在时，返回null
 * @group Storage
 */
const getLocalStorage = (name: string) => {
  if (name) return localStorage.getItem(name);
  return null;
};

/**
 *删除数据
 * @param {String} name 要删除的数据的键名
 * @returns 删除成功，返回true；删除失败，返回false
 * @group Storage
 */
const deleteLocalStorage = (name: string) => {
  if (getLocalStorage(name)) {
    localStorage.removeItem(name);
    return true;
  }
  return false;
};

/**
 * 清除localStorage
 * @returns 成功返回true，失败返回false
 * @group Storage
 */
const clearLocalStorage = () => {
  localStorage.clear();
  return !localStorage.length;
};

export {
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  clearLocalStorage,
};
